import Product from './ProductNewPage';

export default Product;
